import axios from "axios";
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import { courtAdd, uploadCsv } from "../../../api/endpoint";
import toast from "react-hot-toast";
import Select from "react-select";
import { useSelector } from "react-redux";
import Input from "../../../components/input";
import Loader from "../../../components/loader";

const AddMultipleCourtsModal = ({ isAddOpen, closeAddModal, fetchCourts }) => {
  const [csvFile, setCsvFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", csvFile);
      const uploadResponse = await axios.post(uploadCsv, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      });
      try {
        setLoading(true);
        let courts = uploadResponse?.data;
        // courts = courts.slice(2,4)
        const addResponse = await axios.post(courtAdd, courts, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth}`,
          },
        });
        toast.success("Courts submitted successfully!");
        // if (onAddCourt) onAddCourt(response.data);
        //   handleReset();
        fetchCourts();
        closeAddModal();
      } catch (error) {
        const errorMessage = "An unexpected error occurred.";
        toast.error(errorMessage);
        console.error("Error submitting courts:", error);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error("error uploading csv file", error);
      toast.error("Error uploading csv file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={isAddOpen} onHide={closeAddModal} centered>
        <div className="modal-header">
          <h5 className="modal-title">Courts Bulk Upload</h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeAddModal}
          ></button>
        </div>
        <div className="modal-body">
          <form>
            <Input
              label="Upload CSV"
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              value={csvFile}
              onChange={(e) => setCsvFile(e.target.files[0])}
              className="mb-3"
            />
            <Button text="Add Courts" callBack={(e) => handleSubmit(e)} className="float-end"/>
          </form>
        </div>
      </Modal>
      {loading && <Loader />}
    </>
  );
};

export default AddMultipleCourtsModal;
